/**
 * @description question editor model
 * @date 2019-03-29
 * @author jywang
 */
import React from 'react';
import { Input } from 'antd';
import { WithBaiduMediaUpload } from '../../components/HOC/BaiduMediaUpload';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import Arr from '@util/array';
import tool from '@util/tool';
import toast from '@util/toast';
import * as classnames from 'classnames';
import './index.scss';
const { TextArea } = Input;
const tabType = ['图文', '视频'];
@inject('store')
@WithBaiduMediaUpload(inject('store'))
@observer
class QuestionEdit extends React.Component<any, any> {
    public imgList: any = [];
    constructor(props) {
        super(props);
        this.init();
    }
    public init = () => {
        this.state = {
            imgList: [],
            video: '',
            currentTab: 0,
        };
    }
    public render() {
        const { errorStatus, errorContent, type, store } = this.props;
        const { currentTab } = this.state;
        return (
            <div className="question-edit-box">
                <div className="question-tab-box">
                    {
                        tabType.map((item, idx) => {
                            // tslint:disable-next-line: jsx-no-lambda
                            return <span onClick={() => this.switchTab(idx)} className={classnames({ active: currentTab === idx })} key={idx}>{item + this.switchType(type)}</span>;
                        })
                    }
                </div>
                <div className="question-title-box">
                    {type === 'add' ? <div className="question-title-input-box">
                        <Input size="large" onChange={this.titleDescInputChange} onBlur={this.titleOnblur} name="name" maxLength={40} placeholder="请输入问题标题（4-40字，必填）" />
                    </div> :
                        <h3>{store.getDetail.title}</h3>}
                </div>
                <div className="desc-textarea-box">
                    <TextArea name="content" onChange={this.titleDescInputChange} rows={11} autosize={false} maxLength={10000} placeholder="添加描述（不能超过10000字）" />
                </div>
                <div className="add-media-box">
                    <div className="add-img-box" hidden={currentTab !== 0}>
                        <p className="add-media-title">添加图片</p>
                        <ul>
                            {
                                store.addQuestion.images && store.addQuestion.images.map((item, idx) => {
                                    return (<li key={idx}>
                                        <img src={item.url} alt="" />{
                                            // tslint:disable-next-line: jsx-no-lambda
                                            <span className="imgClose" onClick={() => this.delImg(idx)}></span>}
                                    </li>);
                                })
                            }
                            <li className="add-img-input">
                                <input type="file" onChange={this.imgInputChange} name="question-img" id="question-img" value="" multiple={true} accept="image/jpg,image/jpeg,image/png,image/gif" />
                                <span className="iconfont">&#xe71d;</span>
                            </li>
                        </ul>
                    </div>
                    <div className="add-video-box" hidden={currentTab !== 1}>
                        <p className="add-media-title">添加视频</p>
                        <ul>
                            <li className="add-video-input">
                                <input type="file" onChange={this.videoInputChange} name="question-video" id="question-video" multiple={false} accept="audio/mp4, video/mp4,video/mov" value="" />
                                <span className="iconfont">&#xe71d;</span>
                                {store.addQuestion.video && <img src={store.addQuestion.video.cover} alt="" /> || ''}
                                <span hidden={!store.addQuestion.video} className="duration">
                                    <i className="iconfont">&#xe743;</i>
                                    {store.addQuestion.video && store.addQuestion.video.duration}
                                </span>
                                {
                                    // tslint:disable-next-line: jsx-no-lambda
                                    <span hidden={!store.addQuestion.video} className="imgClose" onClick={() => this.delVideo()}></span>}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={classnames('bigScreen', { hide: errorStatus })}>
                    <div className="errInfo">{errorContent}</div>
                </div>
            </div>
        );
    }
    public delImg = (number) => {
        const { store } = this.props;
        const images = store.addQuestion.images && store.addQuestion.images.filter((item, idx) => {
            return idx !== number;
        });
        const param: any = {};
        param.images = images;
        this.imgList = images;
        store.addQuestion.set(param);
    }
    public delVideo = () => {
        const { store } = this.props;
        const param: any = {};
        param.video = null;
        store.addQuestion.set(param);
    }
    public titleOnblur = (e) => {
        const value = e.target.value;

        if (value) {
            const lastChartAt = value.charAt(value.length - 1);
             const name = e.target.name;
            if (lastChartAt !== '?' && lastChartAt !== '？') {
                e.target.value = e.target.value + '?';
                 const { store } = this.props;
                 const param: any = {};
                 param[name] = e.target.value;
                 store.addQuestion.set(param);
            }
        }
    }

    public titleDescInputChange = (e) => {
        console.log(e.target.name);
        const name = e.target.name;
        const { store } = this.props;
        const param: any = {};
        param[name] = e.target.value;
        store.addQuestion.set(param);
        console.log(store.addQuestion);
    }

    public imgInputChange = (e) => {
        const files = e.target.files;
        const { store } = this.props;
        Arr.arrForEach(files, (file) => {
            if (this.imgList.length < 50) {
                this.props.getStsWrite(file, (data) => {
                    if (this.imgList.length < 50) {
                        const imgInfo: any = {};
                        if (data.url) {
                            imgInfo.url = data.url;
                            imgInfo.imageRes = data.pixel;
                            this.imgList.push(imgInfo);
                            console.log(this.imgList);
                            const param: any = {};
                            param.images = this.imgList;
                            store.addQuestion.set(param);
                            console.log(store.addQuestion);
                        } else {
                            // alert('图片上传失败');
                            toast.error('图片上传失败');
                        }
                    } else {
                        toast.error('只能上传9张图片');
                    }
                });
            } else {
                toast.error('只能上传9张图片');
            }

        });
    }
    public videoInputChange = (e) => {
        const files = e.target.files;
        // this.props.getStsUpload
        const videoInfo: any = {};
        const { store } = this.props;
        Arr.arrForEach(files, (file) => {
            this.props.getStsUpload(file, (data) => {
                videoInfo.cover = data.snapshots[0];
                videoInfo.videoId = data.videoId;
                videoInfo.videoRes = data.pixel;
                videoInfo.videoUrlSource = data.PlayInfo[0]['playURL'];
                videoInfo.duration = tool.secondToDate(data.duration);
                const param: any = {};
                param.video = videoInfo;
                console.log(param);
                store.addQuestion.set(param);
                console.log(data);
            });
        });
    }
    public switchType = (type) => {
        switch (type) {
            case 'add':
                return '提问';
            case 'update':
                return '回答';
            default:
                return '';
        }
    }
    public switchTab = (idx) => {
        const { store } = this.props;
        const param: any = {};
        param.type = idx;
        store.addQuestion.set(param);
        this.setState({
            currentTab: idx,
        });
    }
}
export default QuestionEdit;
